module.exports = __webpack_public_path__ + "files/ce1551aced2c5d0a622573d6aaafba77.png";